import { useTranslation } from 'react-i18next'

import Flexer from 'js/components/Flexer/Flexer'
import Tag from 'js/components/Tag/Tag'
import { partitionArray } from 'js/lib/helpers'
import { useRoleLabelAll } from 'js/lib/helpers/useRoleLabel'

interface Props {
    roles?: string[] | null
    isOwner?: boolean
    className?: string
}

export const Roles = ({ roles = [], isOwner, className }: Props) => {
    const { t } = useTranslation()

    const [siteRoles, groupRoles] = partitionArray(
        roles,
        (role: string) => !role?.startsWith('GROUP_'),
    )

    const roleLabels = useRoleLabelAll(siteRoles, isOwner)
    const groupRoleLabels = useRoleLabelAll(groupRoles, isOwner)

    return (
        <Flexer
            gutter="tiny"
            justifyContent="flex-start"
            data-testid="roles"
            wrap
            className={className}
        >
            {roleLabels?.map((roleLabel) => (
                <Tag variant="primary" radiusStyle="round" key={roleLabel}>
                    {roleLabel}
                </Tag>
            ))}
            {groupRoleLabels?.map((roleLabel) => (
                <Tag
                    variant="primary"
                    radiusStyle="round"
                    prefix={t('global.group')}
                    key={roleLabel}
                >
                    {roleLabel}
                </Tag>
            ))}
        </Flexer>
    )
}

export default Roles
